var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.country && _vm.locale && _vm.country.columns.shortTitle)?_c('span',[_vm._v(_vm._s(_vm.country.columns.shortTitle[_vm.locale.columns.language]))]):_c('span',[_vm._v("Country Missing")])}
var staticRenderFns = []

export { render, staticRenderFns }